import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

const NoAccountsMessage = ({ statusFilter, getFilterDisplayText }) => {
  if (statusFilter) {
    const filterText = getFilterDisplayText(statusFilter).toLowerCase();
    return (
      <Typography variant="h6" sx={{
        color: "text.secondary"
      }}>No {filterText}accounts found
              </Typography>
    );
  }
  return (
    <Typography variant="h6" sx={{
      color: "text.secondary"
    }}>No accounts found for the selected filters
          </Typography>
  );
};

NoAccountsMessage.propTypes = {
  statusFilter: PropTypes.string.isRequired,
  getFilterDisplayText: PropTypes.func.isRequired
};

export default NoAccountsMessage;